import { render, staticRenderFns } from "./GroupInviteLink.vue?vue&type=template&id=a6c68438&scoped=true&"
import script from "./GroupInviteLink.vue?vue&type=script&lang=js&"
export * from "./GroupInviteLink.vue?vue&type=script&lang=js&"
import style0 from "./GroupInviteLink.vue?vue&type=style&index=0&id=a6c68438&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c68438",
  null
  
)

export default component.exports